import { ImisMessageType } from "./imis.models";

export class ToastMessageProperties {
    messageId: string;
    message: string;
    messageType?: ImisMessageType;
    autoDismiss?: boolean;
    autoDismissSeconds?: number;
    confirmationDialog?: ToastMessageConfirmationProperties;

    constructor() {        
        this.messageType = ImisMessageType.INFORMATION;
        this.autoDismiss = true;
        this.autoDismissSeconds = 3;
    }
}

export interface ToastMessageConfirmationProperties {
    onConfirm: () => void;
    onCancel: () => void;
}